import * as React from 'react';
import { Dimmer } from 'semantic-ui-react';
import { CustomizeReportRequest, RowsRequest, } from '~/Api/Report';
import { useApiResult } from '~/ApiHooks';
import { Table } from '~/ReportTable/Table';
import { Placeholder } from '~/UI';
export var ReportTable = function (_a) {
    var reportSettings = _a.reportSettings, customized = _a.customized, selectColumn = _a.selectColumn, reportId = _a.reportId, query = _a.query, onChange = _a.onChange, headers = _a.headers, sort = _a.sort, custom = _a.custom;
    var request = customized === 0
        ? new RowsRequest(reportId, query, custom)
        : new CustomizeReportRequest(reportId, custom, reportSettings, query);
    var rows = useApiResult(request, [
        reportId,
        query.page,
        customized,
    ])[0];
    if (rows.value === null && rows.isLoading) {
        return <Placeholder />;
    }
    if (rows.value === null) {
        return null;
    }
    return (<Dimmer.Dimmable dimmed={rows.isLoading}>
			<Dimmer inverted active={rows.isLoading}/>
			<Table headers={headers} pagination={rows.value.pagination} query={query} rows={rows.value.items.slice(0, 50)} selectColumn={selectColumn} sort={sort} onChange={onChange}/>
		</Dimmer.Dimmable>);
};
